import React from 'react';
import { Award, Sparkles, Trophy, Users } from 'lucide-react';
import { motion } from 'framer-motion';
export function TrustBadges() {
  const badges = [{
    icon: <Award strokeWidth={1.5} size={32} className="text-taupe-dark" data-id="element-198" />,
    text: 'Industry Leaders in\nScar Camouflage'
  }, {
    icon: <Sparkles strokeWidth={1.5} size={32} className="text-taupe-dark" data-id="element-199" />,
    text: 'Creator of The\nParkway Method'
  }, {
    icon: <Trophy strokeWidth={1.5} size={32} className="text-taupe-dark" data-id="element-200" />,
    text: 'Best Results\nGuaranteed'
  }, {
    icon: <Users strokeWidth={1.5} size={32} className="text-taupe-dark" data-id="element-201" />,
    text: 'Developed by Former\nAllon Artists'
  }];
  return <section className="bg-white border-y border-taupe/20 py-16 px-6" data-id="element-202">
      <div className="max-w-[1400px] mx-auto" data-id="element-203">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6" data-id="element-204">
          {badges.map((badge, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className="flex flex-col items-center text-center gap-4" data-id="element-205">
              <div className="p-4 rounded-full bg-cream" data-id="element-206">{badge.icon}</div>
              <p className="font-sans text-sm tracking-wide text-black/80 whitespace-pre-line leading-relaxed" data-id="element-207">
                {badge.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}